import * as React from 'react';
import { connect } from 'react-redux';
import { BREADCRUMBS_REDUCER_NAME } from 'src/react/components/breadcrumbs/constants';
import Crumbs from 'src/react/components/breadcrumbs/components/Crumbs';
import reducer from 'src/react/components/breadcrumbs/reducers';
import { reducerRegistry } from '@collaborator/npm_modules/dist/components/redux';
reducerRegistry.register(BREADCRUMBS_REDUCER_NAME, reducer);

var Breadcrumbs = function Breadcrumbs(_ref) {
  var crumbs = _ref.crumbs;
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "breadcrumb"
  }, /*#__PURE__*/React.createElement(Crumbs, {
    crumbs: crumbs
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    crumbs: state[BREADCRUMBS_REDUCER_NAME].crumbs
  };
};

export default connect(mapStateToProps)(Breadcrumbs);